import { StrictMode } from 'react';
import ErrorBoundaryApp from '../error-boundary/error-boundary.app';
import NavigationApp from '../navigation/navigation.app';
import ProviderApp from '../provider/provider.app';

export default function ContainerApp() {
  return (
    <StrictMode>
      <ErrorBoundaryApp>
        <ProviderApp>
          <NavigationApp />
        </ProviderApp>
      </ErrorBoundaryApp>
    </StrictMode>
  );
}
